import { tv } from 'tailwind-variants';

const labelStyles = tv({
  base: 'inline-flex text-sm mb-1',
  variants: {
    design: {
      external: 'text-secondary-one',
    },
    errored: {
      true: 'text-primary-two',
    },
  },
});

const containerStyles = tv({
  base: 'rounded-lg bg-white min-w-[100px] hover:cursor-pointer static box-border',
  variants: {
    design: {
      external: 'bg-zinc-50 h-8',
    },
    errored: {
      true: 'border border-primary-two',
    },
  },
});

const controlStyles = tv({
  base: 'pl-2',
  variants: {
    design: {
      external: 'border-0 h-8 bg-zinc-100 rounded',
    },
    focus: {
      false: 'border-gray-300 hover:border-gray-400',
    },
  },
});

const placeholderStyles = tv({
  base: 'text-gray-500 py-0.5 text-sm',
  variants: {
    design: {
      external: 'text-sm',
    },
  },
});

const selectInputStyles = tv({
  base: 'ml-2 py-0.5 text-sm',
  variants: {
    design: {
      external: '',
    },
  },
});

const valueContainerStyles = tv({
  base: 'p-1 gap-1',
  variants: {
    design: {
      external: 'py-0',
    },
    disabled: {
      true: 'text-gray-400',
    },
  },
});

const singleValueStyles = tv({
  base: 'leading-7 text-sm',
  variants: {
    design: {
      external: 'text-sm',
    },
    disabled: {
      true: 'text-gray-400',
    },
  },
});

const indicatorsContainerStyles = tv({
  base: 'flex items-center justify-center p-1 gap-1',
  variants: {
    design: {
      external: 'py-0 h-full',
    },
  },
});

const clearIndicatorStyles = tv({
  base: 'text-gray-500 p-1 rounded-md hover:bg-red-50 hover:text-red-800',
  variants: {
    design: {
      external: '',
    },
  },
});

const indicatorSeparatorStyles = tv({
  base: 'bg-gray-300 h-5 my-auto',
  variants: {
    design: {
      external: '',
    },
  },
});

const dropdownIndicatorStyles = tv({
  base: 'p-1 hover:bg-gray-100 text-gray-500 rounded-md hover:text-black',
  variants: {
    design: {
      external: '',
    },
    error: {
      true: 'text-primary-two',
    },
  },
});

const menuStyles = tv({
  base: 'p-1 mt-2 border border-gray-200 bg-white rounded-lg shadow-lg z-[120] text-sm',
  variants: {
    design: {
      external: '',
    },
  },
});

const groupHeadingStyles = tv({
  base: 'ml-3 mt-2 mb-1 text-gray-500 text-sm',
  variants: {
    design: {
      external: '',
    },
  },
});

const optionStyles = tv({
  base: 'relative hover:cursor-pointer px-3 py-2 rounded text-sm',
  variants: {
    design: {
      external: '',
    },
    focus: {
      true: 'bg-zinc-100 active:bg-gray-200',
    },
    selected: {
      true: 'opacity-60 after:content-["✓"] after:font-medium after:text-lg after:size-2 after:absolute after:right-4 after:top-2 after:leading-none',
    },
  },
});

const noOptionsMessageStyles = tv({
  base: 'text-gray-500 p-2 bg-gray-50 border border-dashed border-gray-200 rounded-sm',
  variants: {
    design: {
      external: '',
    },
  },
});

export const singleSelectStyles = {
  label: labelStyles,
  container: containerStyles,
  control: controlStyles,
  placeholder: placeholderStyles,
  input: selectInputStyles,
  valueContainer: valueContainerStyles,
  singleValue: singleValueStyles,
  indicators: indicatorsContainerStyles,
  clearIndicator: clearIndicatorStyles,
  indicatorsContainer: indicatorsContainerStyles,
  indicatorSeparator: indicatorSeparatorStyles,
  dropdownIndicator: dropdownIndicatorStyles,
  menu: menuStyles,
  groupHeading: groupHeadingStyles,
  option: optionStyles,
  noOptionsMessage: noOptionsMessageStyles,
};
